/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Boiler_Room_InconsistencyInputs */



/**
* | output |
* | --- |
* | "Inconsistency between boiler rooms" |
*
* @param {Boiler_Room_InconsistencyInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const boiler_room_inconsistency = /** @type {((inputs?: Boiler_Room_InconsistencyInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Boiler_Room_InconsistencyInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Inconsistency between boiler rooms")
	return /** @type {LocalizedString} */ ("Incohérence entre les chaufferies")
});